var _defs, _style, _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUnfathomableAbyssActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 128 128",
    width: 128,
    height: 128,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "P",
    gradientUnits: "userSpaceOnUse"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g1",
    cx: 64.3,
    cy: 64.2,
    r: 12.3,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#903695"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1e0934"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g2",
    cx: 64.4,
    cy: 64.2,
    r: 15.6,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#903695"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1e0934"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g3",
    cx: 64.3,
    cy: 64.2,
    r: 8.1,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#903695"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1e0934"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g4",
    cx: 64.3,
    cy: 64.2,
    r: 53.5,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#463855"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#242a64"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#653b97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#903695"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ed3097"
  })))), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".a{fill:#1f0a34}.b{fill:url(#g1);stroke:#010204;stroke-width:.4}.c{fill:url(#g2);stroke:#010204;stroke-width:.4}.d{fill:url(#g3);stroke:#010204;stroke-width:.4}.e{fill:url(#g4)}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m127.5 64.2c0 35.1-28.5 63.6-63.6 63.6-35.1 0-63.5-28.5-63.5-63.6 0-35.1 28.4-63.5 63.5-63.5 35.1 0 63.6 28.4 63.6 63.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m76.6 64.2c0 6.8-5.5 12.3-12.3 12.3-6.8 0-12.3-5.5-12.3-12.3 0-6.8 5.5-12.3 12.3-12.3 6.8 0 12.3 5.5 12.3 12.3z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "m80 64.2c0 8.7-7 15.6-15.6 15.6-8.7 0-15.6-6.9-15.6-15.6 0-8.6 6.9-15.6 15.6-15.6 8.6 0 15.6 7 15.6 15.6z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "m72.4 64.2c0 4.5-3.6 8.2-8.1 8.2-4.5 0-8.1-3.7-8.1-8.2 0-4.4 3.6-8.1 8.1-8.1 4.5 0 8.1 3.7 8.1 8.1z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "e",
    d: "m56.5 99c21.1 12 51.6 0.3 61.3-28.4 0 0-10.6 29.1-37.5 31.1-26.2 2.1-33.3-17.6-33.1-22.1 0.9 2.3 8.4 20 31.1 17.5 24.2-2.7 41.9-30.1 32.9-59 0 0 8.5 29.7-12 47.2-20.5 17.5-38.2 4.7-40 1.3l-0.1-0.1q0.3 0.1 0.6 0.2h-0.4c0 0 17.7 12.4 35.7-4 17.9-16.4 16.2-49-8-67.1 0 0 24.3 19.1 18 45.2-6.3 26.2-28.1 26.3-31.6 24.6l-0.4 0.1q0.1-0.1 0.3-0.1c1.9-0.1 21.6-1.5 26.3-24.2 4.9-23.9-15.7-49.2-45.9-49.6 0 0 30.9 1.1 41.2 26 10 24.3-6.5 37.2-10.8 38.4q0.2-0.4 0.4-0.8c3.1-2.7 15.4-15 6.5-34.6-10-22.1-41.5-30.5-66.3-13.1 0 0 25.7-17.2 48.7-3.1 22.3 13.7 16.6 33.8 13.8 37.3q0-0.1 0-0.2c0.8-3.6 3.9-21.2-15-32-21.2-12-51.6-0.3-61.4 28.4 0 0 10.7-29.1 37.5-31.1 26.2-2.1 33.4 17.6 33.2 22.1q-0.1-0.1-0.1-0.1c-0.7-2-8.2-20.1-31.1-17.5-24.2 2.7-41.9 30.1-33 59 0 0-8.4-29.8 12.1-47.2 20.5-17.5 38.2-4.8 39.9-1.4l0.1 0.1q-0.1-0.1-0.3-0.1h0.2c0 0-17.6-12.4-35.6 4-18 16.4-16.2 49 8 67.1 0 0-24.3-19.1-18-45.3 6.3-26.1 28.1-26.3 31.5-24.5l0.4-0.1q-0.2 0.1-0.5 0.2c-2.4 0.2-21.6 1.9-26.2 24.2-4.9 23.9 15.7 49.2 45.9 49.6 0 0-30.9-1.1-41.1-26-10.2-24.6 6.8-37.5 10.9-38.4q-0.1 0.1-0.2 0.3c-1.9 1.5-16.4 14.2-7 34.9 10.1 22.2 41.6 30.6 66.3 13.2 0 0-25.6 17.2-48.6 3.1-22.9-14.1-16.3-34.9-13.6-37.6q0 0.2 0 0.4c-0.7 3-4.4 21.1 15 32.2zm-9.7-34.8c0 9.7 7.8 17.6 17.6 17.6 9.7 0 17.6-7.9 17.6-17.6 0-9.7-7.9-17.6-17.6-17.6-9.8 0-17.6 7.9-17.6 17.6zm0.4 15.3q0 0 0-0.1 0 0.1 0 0.1z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnfathomableAbyssActive);
export default __webpack_public_path__ + "static/media/unfathomable-abyss-active.8614c6e101f168b7c94b929967ed9775.svg";
export { ForwardRef as ReactComponent };